import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Spinner } from "react-bootstrap";
import { LANCONTEXT } from "../Context/LanContext";
import smile_arr from "../../Assets/Images/smile.json";
import smile_arr_tamil from "../../Assets/Images/smile_tamil.json";
import Excellent from "../../Assets/Images/Excellent.png";
import Good from "../../Assets/Images/Good.png";
import Average from "../../Assets/Images/Average.png";
import Poor from "../../Assets/Images/Poor.png";
import Na from "../../Assets/Images/Na.png";
import alternate from "../../Assets/Images/tick.png";
import "./FeedBack.css";

const baseUrl = "https://hsissmart.psghospitals.com/ps1/api/feedback";
const img_arr = [
  { id: 1, img: Excellent },
  { id: 2, img: Good },
  { id: 3, img: Average },
  { id: 4, img: Poor },
  { id: 5, img: Na },
];

const FEEDBACK = () => {
  const [data, setData] = useState("");
  const { lan } = useContext(LANCONTEXT);
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({
    name: "",
    MOBILE: "",
    OP_NO: "",
    VISIT_DATE: "",
    IP_NO: "",
    EMAIL: "",
  });
  const [ratings, setRatings] = useState({});
  const [comments, setComments] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState("");
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Validate each input
    let error = "";
    if (name === "name" && !/^[A-Za-z\s]*$/.test(value)) {
      error = "Name can only contain letters .";
    } else if (name === "MOBILE" && !/^\d{0,10}$/.test(value)) {
      error = "Mobile number must be a 10-digit number.";
    } else if (name === "OP_NO" && value.length > 9) {
      error = "OP Number must be exactly 9 characters.";
    } else if (name === "IP_NO" && value.length > 9) {
      error = "IP Number must be exactly 9 characters.";
    } else if (
      name === "EMAIL" &&
      !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)
    ) {
      error = "Email must be a valid format (e.g., user@example.com).";
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    if (!error) {
      setLoginData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCommentChange = (i, y, value) => {
    setComments((prev) => ({ ...prev, [`comment${i}${y}`]: value }));
  };

  const handleRatingClick = (i, y, z) => {
    setRatings((prev) => ({ ...prev, [`rating${i}${y}`]: z + 1 }));

    // Show remark box only for "Average" (3) and "Poor" (4) ratings
    const textArea = document.querySelector(`.simle_div_text_area${i}${y}`);
    textArea.style.display = z === 2 || z === 3 ? "block" : "none";

    for (let x = 0; x < 5; x++) {
      document.querySelector(`.smileimg${i}${y}${x}`).src = img_arr[x].img;
    }
    document.querySelector(`.smileimg${i}${y}${z}`).src = alternate;
  };

  const forSubmit = () => {
    const smiles = lan ? smile_arr : smile_arr_tamil;
    smiles.forEach((e, i) => {
      e.subheading.forEach((_, y) => {
        for (let z = 0; z < 5; z++) {
          const image = document.querySelector(`.smileimg${i}${y}${z}`);
          if (image) image.src = img_arr[z].img;
        }
      });
    });
  };

  const formatDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  const postName = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formattedDate = formatDate(loginData.VISIT_DATE);

    // Ensure all ratings are set to a default value if not clicked
    const smiles = lan ? smile_arr : smile_arr_tamil;
    smiles.forEach((e, i) => {
      e.subheading.forEach((_, y) => {
        const ratingKey = `rating${i}${y}`;
        if (!ratings[ratingKey]) {
          setRatings((prev) => ({ ...prev, [ratingKey]: 0 }));
        }
      });
    });

    const postData = {
      ...loginData,
      VISIT_DATE: formattedDate,
      HA_DIRECTION_BOARD: ratings["rating00"] || "",
      HA_DIRECTION_BOARD_REMARK: comments["comment00"] || "",
      HA_CLEANLINESS: ratings["rating01"] || "",
      HA_CLEANLINESS_REMARK: comments["comment01"] || "",
      OP_APPOINTMENT: ratings["rating10"] || "",
      OP_APPOINTMENT_REMARK: comments["comment10"] || "",
      OP_REGISTRATION: ratings["rating11"] || "",
      OP_REGISTRATION_REMARK: comments["comment11"] || "",
      OP_PRO_GUIDANCE: ratings["rating12"] || "",
      OP_PRO_GUIDANCE_REMARK: comments["comment12"] || "",
      OP_TREATMENT: ratings["rating13"] || "",
      OP_TREATMENT_REMARK: comments["comment13"] || "",
      OP_NURSING_CARE: ratings["rating14"] || "",
      OP_NURSING_CARE_REMARK: comments["comment14"] || "",
      OP_OP_BILLING: ratings["rating15"] || "",
      OP_OP_BILLING_REMARK: comments["comment15"] || "",
      OP_OPD_SERVICES: ratings["rating16"] || "",
      OP_OPD_SERVICES_REMARK: comments["comment16"] || "",
      OP_LABORATORY: ratings["rating17"] || "",
      OP_LABORATORY_REMARK: comments["comment17"] || "",
      OP_RADIOLOGY: ratings["rating18"] || "",
      OP_RADIOLOGY_REMARK: comments["comment18"] || "",
      OP_PARA_MEDICAL_SERVICES: ratings["rating19"] || "",
      OP_PARA_MEDICAL_SERVICES_REMARK: comments["comment19"] || "",
      OP_PHARMACY: ratings["rating110"] || "",
      OP_PHARMACY_REMARK: comments["comment110"] || "",
      OP_PHYSIOTHERAPY: ratings["rating111"] || "",
      OP_PHYSIOTHERAPY_REMARK: comments["comment111"] || "",
      OP_SUPPORTIVE_SERVICES: ratings["rating112"] || "",
      OP_SUPPORTIVE_SERVICES_REMARK: comments["comment112"] || "",
      IP_ADMISSION: ratings["rating20"] || "",
      IP_ADMISSION_REMARK: comments["comment20"] || "",
      IP_FACILITIES: ratings["rating21"] || "",
      IP_FACILITIES_REMARK: comments["comment21"] || "",
      IP_SPACE: ratings["rating22"] || "",
      IP_SPACE_REMARK: comments["comment22"] || "",
      IP_PRIVACY: ratings["rating23"] || "",
      IP_PRIVACY_REMARK: comments["comment23"] || "",
      RS_DIETARY: ratings["rating24"] || "",
      RS_DIETARY_REMARK: comments["comment24"] || "",
      RS_HOUSE_KEEPING: ratings["rating25"] || "",
      RS_HOUSE_KEEPING_REMARK: comments["comment25"] || "",
      OS_IP_BILLING: ratings["rating30"] || "",
      OS_IP_BILLING_REMARKS: comments["comment30"] || "",
      OS_INSURANCE: ratings["rating31"] || "",
      OS_INSURANCE_REMARK: comments["comment31"] || "",
      OTHER_REMARK: remarks,
      // ENTRY_IP_ADDRESS: "192.168.1.1",
      // ENTRY_LOCATION: "Hospital",
    };

    console.log("Posting data:", postData); // Debugging
    console.log("Ratings:", ratings); // Debugging
    console.log("Comments:", comments); // Debugging

    try {
      const response = await fetch(`${baseUrl}/insertfeedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });
      const result = await response.json();
      console.log("Response data:", result); // Debugging
      setData(result.message);
      forSubmit();
      navigate("/success", {
        state: { message: result.message, data: postData },
      });
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } catch (error) {
      console.error("Error posting data:", error);
    }
    setLoading(false);
  };

  const smile_heading = {
    1: "Excellent",
    2: "Good",
    3: "Average",
    4: "Poor",
    5: "Na",
  };

  const smile_heading_tamil = {
    1: "சிறப்பானது",
    2: "நன்று",
    3: "சராசரி",
    4: "மோசமான",
    5: "பொருந்தாது",
  };

  const smiles = lan ? smile_arr : smile_arr_tamil;

  return (
    <div className="feedback_all_feed">
      <div className="feedback">
        <h3 className="feedback_heading">
          {lan
            ? " PSG  Hospitals Patient Feedback Form"
            : "நோயாளியின் கருத்து படிவம்"}
        </h3>
        {loading ? (
          <div className="loading-wrapper">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : (
          <Form onSubmit={postName}>
            <div className="form-group">
              <label>
                {lan ? "Name" : "பெயர்"}
                <span className="mrd_star">*</span>
              </label>
              {/* {errors.name && <span className="error">{errors.name}</span>} */}
              <input
                type="text"
                className="form-control"
                name="name"
                onChange={handleInputChange}
                value={loginData.name}
                required
              />
              {/* {errors.name && <span className="error">{errors.name}</span>} */}
            </div>
            <div className="form-group">
              <label>
                {lan ? "Mobile" : "கைபேசி எண்"}
                <span className="mrd_star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="MOBILE"
                onChange={handleInputChange}
                value={loginData.MOBILE}
                required
              />
              {/* {errors.MOBILE && <span className="error">{errors.MOBILE}</span>} */}
            </div>
            <div className="form-group">
              <label>
                {lan ? "Visit Date" : "விழா தேதி"}
                <span className="mrd_star">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                name="VISIT_DATE"
                onChange={handleInputChange}
                value={loginData.VISIT_DATE}
                max={new Date().toISOString().split("T")[0]} // Set the max date to today
                required
              />
            </div>
            <div className="form-group">
              <label>
                {lan ? "OP Number" : "ஓ.பி. எண்"}
                {/* <span className="mrd_star">*</span> */}
              </label>
              <input
                type="text"
                className="form-control"
                name="OP_NO"
                onChange={handleInputChange}
                value={loginData.OP_NO}
                // required
              />
              {/* {errors.OP_NO && <span className="error">{errors.OP_NO}</span>} */}
            </div>

            <div className="form-group">
              <label>{lan ? "IP Number" : "ஐ.பி. எண்"}</label>
              <input
                type="text"
                className="form-control"
                name="IP_NO"
                onChange={handleInputChange}
                value={loginData.IP_NO}
              />
              {/* {errors.IP_NO && <span className="error">{errors.IP_NO}</span>} */}
            </div>
            <div className="form-group">
              <label>{lan ? "Email" : "மின்னஞ்சல்"}</label>
              <input
                type="email"
                className="form-control"
                name="EMAIL"
                onChange={handleInputChange}
                // value={loginData.EMAIL}
              />
              {/* {errors.EMAIL && <span className="error">{errors.EMAIL}</span>} */}
            </div>
            {smiles.map((e, i) => (
              <div key={i} className="feedback_section">
                <h4 className="feedback_main_heading">
                  {lan ? e.heading : e.heading_tamil}
                </h4>
                {e.subheading.map((sub, y) => (
                  <div key={y} className="feedback_subsection">
                    <div>
                      <label className="feedback_sub_heading">
                        {lan ? sub : e.subheading_tamil[y]}
                      </label>
                      <div className="smile_div">
                        {img_arr.map((img, z) => (
                          <img
                            key={z}
                            className={`smileimg${i}${y}${z}`}
                            src={img.img}
                            alt={
                              lan
                                ? smile_heading[img.id]
                                : smile_heading_tamil[img.id]
                            }
                            onClick={() => handleRatingClick(i, y, z)}
                          />
                        ))}
                      </div>
                    </div>
                    <textarea
                      className={`simle_div_text_area${i}${y}`}
                      style={{ display: "none" }}
                      placeholder={
                        lan
                          ? "Please give your Remarks for improvement"
                          : "கருத்து"
                      }
                      onChange={(e) =>
                        handleCommentChange(i, y, e.target.value)
                      }
                    ></textarea>
                  </div>
                ))}
              </div>
            ))}
            <Form.Group controlId="remarks">
              <Form.Label>Other Remarks:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </Form.Group>
            <div className="button-container">
              <button type="submit" className="submit_btn">
                {lan ? "Submit" : "சமர்ப்பிக்க"}
              </button>
            </div>
          </Form>
        )}
        {data && <p className="feedback_success_message">{data}</p>}
      </div>
    </div>
  );
};

export default FEEDBACK;
